import React, { useState } from "react";
import { IconButton, Menu, MenuItem, Slide, Toolbar, Tooltip } from "@mui/material";
import {
  Close as CloseIcon,
  Delete as DeleteIcon,
  Download as DownloadIcon,
  DriveFileMove as DriveFileMoveIcon,
  MoreHoriz as MoreHorizIcon,
  SelectAll as SelectAllIcon,
} from "@mui/icons-material";

function MultiSelectToolbar({
  multiSelected,
  selectedIsFolder,
  onClose,
  onSelectAll,
  onDownload,
  onMove,
  onRename,
  onDelete,
  onShare,
}: {
  multiSelected: string[] | null;
  selectedIsFolder: boolean;
  onClose: () => void;
  onSelectAll: () => void;
  onDownload: () => void;
  onMove: () => void;
  onRename: () => void;
  onDelete: () => void;
  onShare: () => void;
}) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const single = multiSelected?.length === 1;

  return (
    <Slide direction="up" in={multiSelected !== null}>
      <Toolbar
        sx={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: 100,
          backgroundColor: (theme) => theme.palette.background.paper,
          borderTop: "1px solid lightgray",
          justifyContent: "space-evenly",
        }}
      >
        <Tooltip title="Clear selection">
          <IconButton color="primary" onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Select all">
          <IconButton color="primary" onClick={onSelectAll}>
            <SelectAllIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="Download">
          <span>
            <IconButton
              color="primary"
              disabled={!single || selectedIsFolder}
              onClick={onDownload}
            >
              <DownloadIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Move to folder">
          <span>
            <IconButton
              color="primary"
              disabled={!multiSelected?.length}
              onClick={onMove}
            >
              <DriveFileMoveIcon />
            </IconButton>
          </span>
        </Tooltip>
        <Tooltip title="Delete">
          <IconButton color="primary" onClick={onDelete}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
        <Tooltip title="More">
          <span>
            <IconButton
              color="primary"
              disabled={!single}
              onClick={(e) => setAnchorEl(e.currentTarget)}
            >
              <MoreHorizIcon />
            </IconButton>
          </span>
        </Tooltip>
        {Boolean(multiSelected?.length) && (
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={() => setAnchorEl(null)}
          >
            {single && (
              <React.Fragment>
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    onRename();
                  }}
                >
                  Rename
                </MenuItem>
                <MenuItem
                  onClick={() => {
                    setAnchorEl(null);
                    onShare();
                  }}
                >
                  {selectedIsFolder ? "Share folder" : "Share"}
                </MenuItem>
              </React.Fragment>
            )}
          </Menu>
        )}
      </Toolbar>
    </Slide>
  );
}

export default MultiSelectToolbar;
